<template>

    <!-- Footer -->
    <mdb-footer color="mdb-color" class="font-small lighten-3">
      <mdb-container class="text-center text-md-left pt-4">
        <h5 class="text-uppercase text-center mb-4 font-weight-bold">联系我们</h5>
        <mdb-row>
          <mdb-col md="6" class="text-left pl-4  pr-5" lg="3">
            <p><mdb-icon icon="home" class="mr-2" />地址：广州市越秀区先烈中路69号东山广场18楼</p>
          </mdb-col>
          <mdb-col md="6" class="text-left pl-4 pr-5" lg="3">
            <p><mdb-icon icon="envelope" class="mr-2" />邮箱：info@gasheng.com</p>
          </mdb-col>
          <mdb-col md="6" class="text-left pl-4 pr-5" lg="3">
            <p><mdb-icon icon="phone" class="mr-2" />全国免费咨询热线：400-930-2818</p>
          </mdb-col>
          <mdb-col md="6" class="text-left pl-4 pr-5" lg="3">
            <p><mdb-icon icon="fax" class="mr-2" />传真： 020-87321120</p>
          </mdb-col>
          <hr class="clearfix w-100 d-md-none"/>
        </mdb-row>
      </mdb-container>
      <div class="footer-copyright text-center py-4 pb-5">
        <mdb-container fluid class="pb-5">
          <a href="/"><h6>广州嘉诚海外投资咨询服务有限公司版权所有</h6></a>
        </mdb-container>
      </div>
    </mdb-footer>
    <!-- Footer -->


</template>
<script>
    export default {
        name: "myFooter"
    }
</script>

<style scoped>

</style>
